'use client';
import { Button } from 'components/ui/button';
import ProviderCapabilities from 'componentsV2/molecules/ProviderPublicContent/ProviderCapabilities';
import ProviderDescription from 'componentsV2/molecules/ProviderPublicContent/ProviderDescription';
import ProviderInformationTabs from 'componentsV2/molecules/ProviderPublicContent/ProviderInformationTabs';
import ProviderKnowMore from 'componentsV2/molecules/ProviderPublicContent/ProviderKnowMore';
import EventPartnerList from 'componentsV2/organisms/EventPartnerList';
import moment from 'moment';
import { useState } from 'react';
import { ProviderPageType } from 'server/provider';
import { getTimezonesData } from 'shared/utils';
import { getTimeZones } from '@vvo/tzdb';
import { t } from 'i18next';

type ComponentProps = {
  provider: ProviderPageType;
};

export default function ProviderMainContent({ provider }: ComponentProps) {
  const { resources, pitchTitle, events, id } = provider;
  const [tab, setTab] = useState('providerContent');

  const showDescription = !!pitchTitle;

  return (
    <main className="flex flex-col">
      <div className="inline-flex w-full overflow-x-auto m-0 p-0">
        <Button
          key={'providerContent'}
          variant="tab"
          aria-selected={tab === 'providerContent'}
          onClick={() => setTab('providerContent')}
        >
          {t('provider_profile')}
        </Button>
        {
          events.length > 0 && (
            <Button
              key={'providerEvent'}
              variant="tab"
              aria-selected={tab === 'providerEvent'}
              onClick={() => setTab('providerEvent')}
            >
              {t('events')}
            </Button>
          )
        }
      </div>

      {tab === 'providerContent' && (
        <div className="flex flex-col gap-8">
          {showDescription && (
            <div className="bg-white rounded-md py-12 px-6 flex flex-col gap-8">
              <ProviderDescription provider={provider} />
            </div>
          )}
          <ProviderInformationTabs provider={provider} />
          <div className="bg-white rounded-md py-12 px-6 flex flex-col gap-8">
            <ProviderCapabilities provider={provider} />
          </div>
          {resources.length > 0 && (
            <div className="bg-white rounded-md py-12 px-6 flex flex-col gap-8">
              <ProviderKnowMore provider={provider} />
            </div>
          )}
        </div>
      )}

      {tab === 'providerEvent' && (
        <div className="bg-white rounded-md py-12 px-6">
          <EventPartnerList
            listEvents
            viewOnly
            events={events}
            providers={[]}
            eventTypes={[]}
            regions={[]}
            products={[]}
            partnerId={null}
            providerId={id}
            userPermissions={[]}
            currentSubTabCalendar={'vcsp'}
            usersTimezoneData={getTimezonesData(
              getTimeZones(),
              moment.tz.guess()
            )}
            editEvents={false}
            moderation={false}
            isSiteAdminPage={false}
            doNotShowViewAllPartner
          />
        </div>
      )}
    </main>
  );
}
